import React from 'react'
import { IconProps } from 'icons/types'
import classnames from 'classnames'
import { FireIcon } from '@heroicons/react/outline'

export const RiskIcon: React.FC<IconProps> = ({ className }: IconProps) => {
  return <FireIcon className={classnames(className)} />
}
